import { AuthenticationFacade, AuthenticationFacadeFactory, Authenticator, TokenParser, } from '@dialectlabs/sdk';
import { SolanaTxTokenBodyParser } from './solana-tx-token-body-parser';
import { SolanaTxTokenGenerator } from './solana-tx-token-generator';
import { SolanaTxTokenValidator } from './solana-tx-token-validator';
export class SolanaTxAuthenticationFacadeFactory extends AuthenticationFacadeFactory {
    constructor(tokenSigner) {
        super();
        this.tokenSigner = tokenSigner;
    }
    static createAuthenticator() {
        return new Authenticator(new TokenParser(new SolanaTxTokenBodyParser()), new SolanaTxTokenValidator());
    }
    get() {
        return new AuthenticationFacade(this.tokenSigner, new SolanaTxTokenGenerator(this.tokenSigner), SolanaTxAuthenticationFacadeFactory.createAuthenticator());
    }
}
//# sourceMappingURL=solana-tx-authentication-facade-factory.js.map